import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 0,
  class: "description"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "buttons",
  id: "rate-types"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "button-text" }

import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import useApplicationData from "@/composables/useApplicationData";


export default /*@__PURE__*/_defineComponent({
  __name: 'RateTypeSelection',
  props: {
    preserveSelection: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();
const route = useRoute();
const router = useRouter();

const { inlineProductDisplay } = useApplicationData();

const selectedRateTypeId = ref<number>(0);

const rateTypes = computed(
  () => store.state.loanConfigurationModule?.loanOptionsConfiguration?.rateTypeSections,
);

const singleRateType = computed<boolean>(
  () => !store.state.loanConfigurationModule.loanOptionsConfiguration.hasFixedAndVariableRates,
);

const title = computed<string>(() => {
  if (singleRateType.value && rateTypes.value && rateTypes.value?.length > 0) {
    const defaultRateType = rateTypes.value[0];

    return `This ${inlineProductDisplay.value} features a ${(
      defaultRateType?.rateTypeName || ""
    )?.toLowerCase()} interest rate.`;
  }
  return "What type of interest rate works best for you?";
});

const error = computed<boolean>(() => store.state.loanConfigurationModule.error);

function formatRateTypeName(rateType: string) {
  return `${rateType} Rate`;
}

const selectedRateType = computed(() => {
  return (rateTypes.value || [])?.find((r: any) => r.rateTypeId === selectedRateTypeId.value);
});

function selectRateType(rateType: any) {
  selectedRateTypeId.value = rateType.rateTypeId;

  if (props.preserveSelection) {
    router.replace({
      query: {
        ...route.query, // Preserve existing queries
        rate: rateType.rateTypeName, // Add/update the 'page' query
      },
    });
  }
}

function setSelectedRate(rateType: string) {
  const rate = rateTypes.value?.find((r: any) => r.rateTypeName === rateType);
  if (rate) {
    selectedRateTypeId.value = rate?.rateTypeId;
    store.dispatch("loanConfigurationModule/setSelectedRateTypeId", selectedRateTypeId.value);
  }
}

function isActive(rateTypeId: number) {
  return selectedRateTypeId.value === rateTypeId;
}

function resetSelectedRateType() {
  selectedRateTypeId.value = 0;
}

watch(
  () => rateTypes.value?.length,
  (count: number) => {
    if (count === 1) {
      setSelectedRate(rateTypes.value[0].rateTypeName);
    }
  },
  {
    immediate: true,
  },
);

__expose({
  isActive,
  rateTypes,
  resetSelectedRateType,
  selectedRateTypeId,
  selectedRateType,
  selectRateType,
  setSelectedRate,
  singleRateType,
  title,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: "section",
    id: "rate-type-selection"
  }, _ctx.$attrs), [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(title.value), 1),
    (!singleRateType.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Learn more about fixed and variable rates by clicking each box. Once you've selected the rate type you prefer, click Continue. Don't worry, you'll still be able to change your selection before choosing your repayment term. "))
      : _createCommentVNode("", true),
    ((rateTypes.value || [])?.length <= 1 && !error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rateTypes.value, (rateType) => {
            return (_openBlock(), _createElementBlock("button", {
              key: rateType.rateTypeId,
              class: _normalizeClass(["rate-type-button", [
          { active: rateType.rateTypeId === selectedRateTypeId.value && !singleRateType.value, singleRateType: singleRateType.value },
        ]]),
              onClick: ($event: any) => (selectRateType(rateType))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(formatRateTypeName(rateType.rateTypeName)), 1)
            ], 10, _hoisted_5))
          }), 128))
        ])),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["section", { single: singleRateType.value }]),
      id: "rate-type-description"
    }, [
      _createElementVNode("h5", null, _toDisplayString(selectedRateType.value?.rateTypeName ? formatRateTypeName(selectedRateType.value?.rateTypeName) : ""), 1),
      _createElementVNode("p", null, _toDisplayString(selectedRateType.value?.rateTypeDescription || ""), 1)
    ], 2), [
      [_vShow, selectedRateTypeId.value > 0]
    ])
  ], 16))
}
}

})